<template>
  <div class="not-found">
    <div class="message">
      <h1>404</h1>
      <p>La página no fue encontrada</p>
      <button
        class="btn"
        @click="goBack">
        Ir atrás
      </button>
    </div>

  </div>
</template>
<script>
export default {
  name: 'PageNotFound',
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>1
<style lang="scss" scoped>
  .not-found {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #222;
    width: 100vw;
    height: 100vh;
    .message {
      padding: 80px;
      h1 {
        font-size: 76px;
        font-weight: 400;
        margin: 0;
        color: #333;
      }
      p {
        font-size: 26px;
        font-weight: 100;
        margin: 0;
        color: #999;
      }
      button {
        border: 1px solid #999;
        background: transparent;
        color: #999;
        margin-top: 20px;
        padding: 10px 20px;
        cursor: pointer;
      }
    }
    .video {
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/page-not-found.view.vue